import browser from 'imports/browser-detect'
import siteCommon from 'site/site-common'
let site = {
    browser:browser(),
    init: function () {
        //add browser name
        $('body').addClass("browser_" + site.browser.name);

        //mobile stuff
        $('.ui-link').removeClass('ui-link');

        //disable img drag
        $('img').on('dragstart', function (event) {
            event.preventDefault();
        });

        if (site.browser.mobile) {
            $('body').addClass("device-mobile");
        } else {
            $('body').addClass("device-notmobile");
        }

        window.addEventListener('resize', site.resize)
        site.resize()

        site.domainsExternalOpen()
    },
    resize () {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`)

        let ol = (window.innerWidth - 1920) /2
        if (ol <0) ol = 0
        document.documentElement.style.setProperty('--offsetLeft', `${ol}px`)

        site.siteOrientationChange()
    },
    siteOrientationChange () {
        //if (isMobile) {

            setTimeout(function () {
                //t.showBlocker = (t.window.innerWidth > t.window.innerHeight)
                //if( (window.orientation === 90 && $( window ).width() < 780) || (window.orientation === -90 && $( window ).width() < 780) ) // Landscape {
            }, 100)
        //}
    },

    domainsExternalOpen() {
        document.querySelectorAll('a[href]').forEach(a => {
            const href = a.getAttribute('href');
            if (!href) return;
            const isInternal =
                href.includes('jimmyawards.com') ||
                href.includes('ddev.site') ||
                href.includes('craft.cloud') ||
                href.startsWith('/') ||
                href.startsWith('#') ||
                href.startsWith('mailto:') ||
                href.startsWith('tel:');
            if (!isInternal) a.setAttribute('target', '_blank');
        });

    }
}
export default site
